@if (routerDataService.routerData.value) {
  <div class="heading-title" [class.no-toggle-menu]="!routerDataService.routerData.value.isShowSidebar">
    @if (layoutService.isMediumDesktopDownView.value && routerDataService.routerData.value.isShowSidebar) {
      <button class="spen-mod-btn is-primary toggle-menu" (click)="slideMenu()">
        <i class="fa fa-reorder"></i>
      </button>
    }
    <h1 class="heading-text">{{ routerDataService.routerData.value.titleH1 }}</h1>
  </div>
}
